<template>
  <div class="price-detail">
    <ul>
      <li class="item-layout" v-if="isAllPayType">
        <div class="">
          <label class="label-ui"
            ><span>商品金额</span
            ><template
              v-if="
                confirmProduct.hasUseBlackGoldPrice == 1 &&
                confirmProduct.blackGoldUser == '1'
              "
            >
              （黑金会员价）</template
            ></label
          >
          <div class="price-ui"><span v-html="price"></span></div>
        </div>
      </li>
      <li>
        <Coupon
          @click.native="trackClickChangeAddress('CHOOSE_COUPON')"
          :product="confirmProduct.skuInfo"
        ></Coupon>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Coupon from './coupon'
import { trackClick } from '../../router/confirmYuesao/ys_ensure_service_tracker'

export default {
  props: {
    isAllPayType: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['confirmProduct', 'selectedCoupon']),
    price() {
      // 不使用黑金价，显示原价
      if (
        this.confirmProduct.blackGoldUser == '1' &&
        this.confirmProduct.hasUseBlackGoldPrice == 0 && 
        this.confirmProduct.priceInfo
      ) {
        return `<i>&yen;</i>${this.confirmProduct.priceInfo.orginprice / 100}`
      }
      if (
        this.confirmProduct.priceInfo &&
        this.confirmProduct.priceInfo.price
      ) {
        return `<i>&yen;</i>${this.confirmProduct.priceInfo.price / 100}`
      } else {
        return 0
      }
    },
    couponPrice() {
      let price = ''
      if (this.confirmProduct && this.confirmProduct.priceInfo) {
        if (this.selectedCoupon && this.selectedCoupon.couponId) {
          price = this.selectedCoupon.couponAmount
          return `- <i>&yen;</i>${price / 100}`
        } else {
          return `<i>&yen;</i>0`
        }
      } else {
        return `<i>&yen;</i>0`
      }
    }
  },
  methods: {
    trackClickChangeAddress(s) {
      trackClick(s)
    }
  },
  components: {
    Coupon
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.price-detail {
  background-color: #fff;
  border-radius: rem(16px);
  margin-top: rem(20px);
  ul {
    padding: rem(18px) 0;
    li {
      line-height: rem(76px);
      &:first-child {
        //  margin-top: rem(-22px);
      }
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: rem(26px);
        color: #333333;
      }
      .coupon-ui {
        color: #ff395e;
        span {
          font-weight: bold;
        }
      }
      .price-ui {
        span {
          font-weight: bold;
        }
      }
    }
  }
}
</style>
